export * from './imagePlusTextBlockMapper';
